import React, { Component } from "react";
import language from "../../assets/languages/language";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import App_data from "../config/App_data";

/* eslint-disable*/
class SignUpApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  signUpAlertModel(e) {
    e.preventDefault();
    this.props.signUpAlertModel(e);
  }

  signUpAlertModelClose(e) {
    e.preventDefault();
    this.props.signUpAlertModelClose(e);
  }

  render() {
    const { signupAlert, signUpAlertModelClose } = this.props;
    return (
      <Modal
        isOpen={signupAlert}
        toggle={this.signUpAlertModel.bind(this)}
        className={
          "modal-primary custom_modalpro info-modal-designing" +
          this.props.className
        }
      >
        <ModalHeader
          toggle={this.signUpAlertModel.bind(this)}
          className="custom-title"
        >
          {language.LC().SIGNUP_Approval_HEADING}
        </ModalHeader>
        <ModalBody className="text-center payment-section-wrap">
          <div className="modal-info-view-for-plan ">
            <img
              src={App_data.frontend_url + "/img/" + "cloud-computing.png"}
              className="mb-2"
              width="90px"
              height="90px"
              alt=""
            />
            <p>{language.LC().SIGNUP_Approval_BODY_1}</p>
            <br />
            <p>{language.LC().SIGNUP_Approval_BODY_2} </p>
            <br />
            <button
              type="button"
              className="btn btn-primary pointer_class"
              onClick={this.signUpAlertModelClose.bind(this)}
            >
              {language.LC().GO_TO_ANSWER}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default SignUpApproval;



// WEBPACK FOOTER //
// ./src/views/Common/signUpApproval.js